import { useEffect } from "react";

const DEFAULT_TITLE = "Les Amis du Web | Création de site internet sur mesure";
const DEFAULT_DESC =
  "Les Amis du Web — agence de création de sites internet sur mesure pour professionnels. Design moderne, rapide, responsive et pensé pour Google. Aperçu gratuit de votre futur site, sans engagement.";
const CANONICAL_BASE = "https://lesamisduweb.fr";

const set = (selector, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute("content", value);
};

export const usePageMeta = ({ title, description } = {}) => {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    const url = `${CANONICAL_BASE}${window.location.pathname}`;
    document.title = t;
    set('meta[name="description"]', d);
    set('meta[property="og:title"]', t);
    set('meta[property="og:description"]', d);
    set('meta[property="og:url"]', url);
    set('meta[name="twitter:title"]', t);
    set('meta[name="twitter:description"]', d);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", url);
  }, [title, description]);
};
